import {
  Button,
  Modal,
  Form,
  Input,
  Flex,
  Typography,
  message,
  Select,
  Row,
  Col,
  Tabs,
  Tree,
  Tooltip,
  Spin
} from "antd";
import React, { forwardRef, useState, useImperativeHandle } from "react";
import { EditOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import { debounce } from "lodash";
import moment from "moment";
import "./index.css"
const UpdateModal = forwardRef((props, ref) => {
  const [form] = Form.useForm();
 const { record: updateModalRef,onSuccess } = props;
  
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [officeList, setOfficeList] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [addRoleList, setAddRoleList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [ownerList, setOwnerList] = useState([]);
  const [trustList, setTrustList] = useState([]);
  const [groupList, setGroupList] = useState([]);
  const [propList, setPropList] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [searchPropValue, setSearchPropValue] = useState("");
  const [managerIdList, setManagerIdList] = useState([]);
  const [accountData, setAccountData] = useState([]);
  const [isSelectVisible, setIsSelectVisible] = useState(false);
  const [selectedAccountView, setSelectedAccountView] = useState(null);
  const [accountViewData, setAccountViewData] = useState([]);
  const [error, setError] = useState(null);
  const [editable, setEditable] = useState(false);
  const [roleList, setRoleList] = useState([]);
  const [roleTabs, setRoleTabs] = useState([]);
    const [anetList, setAnetList] = useState([]);
    const [agentLoading, setAgentLoading] = useState(false);
    const isAgentRequired = Form.useWatch("isInsuranceAgent", form) === 2;
  const isContractManagerList = [
    { value: 1, label: "Yes" },
    { value: 0, label: "No" },
  ];
      const   isInsuranceAgentList = [
    { value: 0, label: " " },
    { value: 1, label: "Yes" },
    { value: 2, label: "No" },
  ];
 useImperativeHandle(ref, () => ({
  showModal: async (record) => {
    try {
      setRoleList([])
      setRoleTabs([])
      setVisible(true);
      setLoading(true);
      const params = { accountId: record.accountId };
      const response = await http.get(api.getAccountDetail, { params });
      const { showAccountList, viewAccountList,managerIds, pList, ...restData } = response.data;
      await getSearchAccount();
      // 回显值
      form.setFieldsValue({
        ...restData,
        accountId: record.accountId,
        showIds: (showAccountList || []).map(item => String(item.accountId)),
        viewIds: (viewAccountList || []).map(item => String(item.accountId)),
        managerIds: (managerIds || []).map(id => String(id)),
        cdate: response.data.cdate ? formatTimestamp(response.data.cdate) : "",
        udate: response.data.udate ? formatTimestamp(response.data.udate) : "",
          });
      console.log(response.data);
      setPropList((pList || []).map(item => ({
        ...item,
        label: item?.propNamePayment || "",
        value: item?.propId ?? "",
      })));

      await Promise.all([
        getCompanyList(),
        getOwner(),
        getTrust(),
        getGroup(),
        getProp(),
        getOfficeList(),
        getRloeListFn(record.accountId),
        getAgentTypeList(),
      ]);
    } catch (error) {
      message.error("Failed to fetch user data");
    } finally {
      setLoading(false);
    }
  }
}));
const formatTimestamp = (ts) => {
  if (!ts) return "";
  const date = new Date(ts);

  return date.toLocaleString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true, // 使用 AM/PM
  });
};
  const getOfficeList = async (search = "") => {
    try {
      const response = await http.get(api.getOfficeList, {
        params: { search },
      });

      if (response.code === "1") {
        const formattedOffices = response.data.map((office) => ({
          value: office,
          label: office,
        }));
        setOfficeList(formattedOffices);
      } else {
        message.error(response.msg || "Failed to fetch office list");
      }
    } catch (error) {
      message.error("Error fetching office list");
      throw error;
    } finally {
    }
  };


  const getOwner = async () => {
    try {
      const response = await http.get(api.getOwnerList);

      if (response.code === "1") {
        const formattedRole = response.data.map((item) => ({
          value: item.ownerId,
          label: item.ownerCode,
        }));
        setOwnerList(formattedRole);
      }
    } catch (error) {
      message.error("Error fetching Company List");
      throw error;
    } finally {
    }
  };

  const getTrust = async () => {
    try {
      const response = await http.get(api.getTrustList);

      if (response.code === "1") {
        const formattedRole = response.data.map((item) => ({
          value: item.trustId,
          label: item.trustName,
        }));
        setTrustList(formattedRole);
        return formattedRole;
      }
    } catch (error) {
      message.error("Error fetching Company List");
      throw error;
    } finally {
    }
  };
  const getGroup = async () => {
    try {
      const response = await http.get(api.getGroupList);

      if (response.code === "1") {
        const formattedRole = response.data.map((item) => ({
          value: item.groupId,
          label: item.groupCode,
        }));
        setGroupList(formattedRole);
      }
    } catch (error) {
      message.error("Error fetching Company List");
      throw error;
    } finally {
    }
  };

  const getCompanyList = async () => {
    try {
      const response = await http.get(api.getCompanyList);

      if (response.code === "1") {
        const formattedRole = response.data.map((item) => ({
          value: item.companyId,
          label: item.companyName,
        }));
        setCompanyList(formattedRole);
      }
    } catch (error) {
      message.error("Error fetching Company List");
      throw error;
    } finally {
    }
  };
const getSearchAccount = async () => {
  try {
    const response = await http.get(`${api.contractSearchAccount}`);
    if (response?.data) {
      const formattedData = response.data.map((item) => ({
        value: String(item.accountId), 
        label: item.allname,     
        allname: item.allname,  
        accountId: item.accountId    
      })).filter(item => item.value);
      
      setAccountData(formattedData);
      setAccountViewData(formattedData);
    }
  } catch (err) {
    setError(err);
  }
};
   const getAgentTypeList = async () => {
     if (anetList.length > 0 || agentLoading) return;
 
     setAgentLoading(true);
 
     try {
       const res = await http.get(api.getAgentType);
       const data = res?.data || res;
 
       const list = (data || []).map((item) => ({
         value: item.vendorId,
         label: item.vendorName,
       }));
 
       setAnetList(list);
     } catch (err) {
       message.error("Request Error");
     } finally {
       setAgentLoading(false);
     }
   };

  const handleChangeUpdata = (value, e) => {
    setSelectedAccount(value);
  };
  const handleClear = () => {
    setSelectedAccount(null);
  };

  const getProp = async (content = "") => {
    const response = await http.get(api.propSearch, { params: { content } });
    if (response.code === "1") {
      const list = (response.data || []).map((item) => ({
        ...item,
        value: item.propId,
        label: item.propName,
      }));
      setPropList(list);
    }
  };

  const handleSearch = debounce((value) => {
    setSearchValue(value);
    getOfficeList(value);
  }, 500);

  const handleChangeView = (value) => {
    form.setFieldsValue({ viewIds: value });
    setSelectedAccount(value);
  };
  const handleClearView = () => {
    setSelectedAccountView(null);
  };

  // 修改用户信息提交
  const onFinishModify = async (values) => {
    try {
      setLoading(true);
      const queryParams = {
        accountId: values.accountId,
        firstname: values.firstname,
        lastname: values.lastname,
        middlename: values.middlename,
        email: values.email,
        phone: values.phone,
        cellphone: values.cellphone,
        occupation: values.occupation,
        education: values.education,
        location: values.location,
        note: values.note,
        office: values.office,
        accessGroup: values.accessGroup,
        ownGroup: values.ownGroup,
        ownTrust: values.ownTrust,
        ext: values.ext,
        accountRoleId: values.accountRoleId,
        groupIds: values.groupIds,
        propIds: values.propIds,
        companyIds: values.companyIds,
        ownerIds: values.ownerIds,
        trustIds: values.trustIds,
        location: values.location,
        note: values.note,
        showIds: values.showIds || "",
        viewIds: values.viewIds || "",
        isContractManager: values.isContractManager,
        managerIds: values.managerIds,
        enableApp: values.enableApp,
        roleIds: values?.roleIds || [],
          isInsuranceAgent:values.isInsuranceAgent,
      agentIds: values.agentIds || [],
      };
       console.log(queryParams);
      const response = await http.post(`${api.getUpdateAccount}`, queryParams);
      if (response.code === "1") {
        message.success("User updated successfully");
        setVisible(false);
        form.resetFields();
        onSuccess?.();
        // window.location.reload();
      } else {
        message.error(response.msg || "Update failed");
      }
    } catch (error) {
      message.error(error.message || "Update failed");
    } finally {
      setLoading(false);
    }
  };

  const getRloeListFn = async (accountId) => {
      const response = await http.get(api.getRoleMenuByAccountId, {params: { accountId }});
      if (response.code === "1") {
        const {list = [], roleIds = []} = response?.data
        const roleListTemp = (list || [])?.map((item) => ({
          value: item.roleId,
          label: item.roleName,
          remark: item.remark,
          menuList: convertToTreeData(item.menuList).treeData,
          checkedKeys: convertToTreeData(item.menuList).checkedKeys,
        }))
        setRoleList(roleListTemp);
        if(roleIds?.length){
          roleListChangeFn(roleIds, roleListTemp)
          form.setFieldsValue({roleIds})
        }
      }
  };

  const roleListChangeFn = (list, roleListTemp = []) => {
    setRoleTabs((roleList?.length ? roleList : roleListTemp).filter(item => list.includes(item.value)))
  }

  const convertToTreeData = (data) => {
    if (!data) return { treeData: [], checkedKeys: [] };
    const checkedKeys = [];

    const convert = (nodes) => {
      return nodes.map((item) => {
        if (item.sfyxz === 1) {
          checkedKeys.push(item.menuId.toString());
        }

        return {
          title: item.menuName,
          key: item.menuId.toString(),
          children:
            item.childNode?.length ? convert(item.childNode) : undefined,
        };
      });
    };

    const treeData = convert(data);
    return { treeData, checkedKeys };
  };

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };

  return (
 <Modal
        title={
          <Flex justify="flex-start" align="flex-start" className="model_title">
            <EditOutlined className="model_title_mr10" />
            <Typography.Title level={4} className="mg">
              MODIFY USER INFORMATION
            </Typography.Title>
          </Flex>
        }
        width="80%"
        open={visible}
        onCancel={() => {
          setVisible(false);
          form.resetFields();
          setEditable(false);
        }}
        centered
        footer={
           <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
          <Button
            key="back"
            onClick={() => {
              setVisible(false);
              form.resetFields();
              setEditable(false);
            }}
          >
            Cancel
          </Button>

          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={() => form.submit()}
            disabled={loading}
          >
            Submit
          </Button>
        </div>}
         destroyOnClose
      >
          <Spin spinning={loading} tip="Loading...">
        <Flex justify="space-between" align="flex-start">
          <div className="model_top" style={{ width: "100%",  margin: '0 24px' }}>
            <div className="model_content" style={{ width: '100%', marginLeft: 0 }}>
              <Form
                {...layout}
                 form={form} 
                onFinish={onFinishModify}
                labelCol={{ style: { width: "150px" } }}
                wrapperCol={{ style: { flex: 1 } }}
              >
                <Row gutter={[16, 16]}>
                  <Col span={7}>
                    <div
                      style={{
                        marginBottom: "16px",
                        fontWeight: "bold",
                        fontSize: "20px",
                        marginLeft: "20px",
                      }}
                    >
                      User Contact Info
                    </div>
                    <Form.Item name="firstname" label="First Name">
                      <Input
                        placeholder="Please fill in first name."
                        allowClear
                        // disabled={!editable}
                      />
                    </Form.Item>

                    <Form.Item name="middlename" label="Middle Name">
                      <Input
                        placeholder="Please fill in middle name."
                        allowClear
                        // disabled={!editable}
                      />
                    </Form.Item>

                    <Form.Item name="lastname" label="Last Name">
                      <Input
                        placeholder="Please fill in last name."
                        allowClear
                        // disabled={!editable}
                      />
                    </Form.Item>

                    <Form.Item name="email" label="Email/login">
                      <Input
                        placeholder="Enter email"
                        allowClear
                        disabled={!editable}
                      />
                    </Form.Item>

                    <Form.Item name="phone" label="Office Phone">
                      <Input
                        type="text"
                        placeholder="Please enter your cell phone number"
                        allowClear
                      />
                    </Form.Item>

                    <Form.Item name="ext" label="Extension">
                      <Input
                        placeholder="Please enter your extension."
                        allowClear
                        // disabled={!editable}
                      />
                    </Form.Item>

                    <Form.Item name="cellphone" label="Cell Phone">
                      <Input
                        type="text"
                        placeholder="Please enter your cell phone number"
                        allowClear
                      />
                    </Form.Item>

                    <Form.Item name="location" label="Company Work Under">
                      <Input
                        placeholder="Please enter Company Work Under"
                        allowClear
                        // disabled={!editable}
                      />
                    </Form.Item>

                    <Form.Item name="office" label="Office Location">
                      <Select
                        placeholder="Select work office"
                        options={officeList}
                        onSearch={handleSearch}
                        allowClear
                        showSearch
                        optionFilterProp="label"
                        filterOption={(input, option) =>
                          option.label
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      />
                    </Form.Item>

                    <Form.Item name="note" label="Note">
                      <Input
                        placeholder="Please enter note"
                        allowClear
                        // disabled={!editable}
                      />
                    </Form.Item>

                    <div
                      style={{
                        marginBottom: "16px",
                        fontWeight: "bold",
                        fontSize: "20px",
                        marginLeft: "20px",
                      }}
                    >
                      User Account Access
                    </div>

                    <Form.Item name="roleIds" label="Role">
                      <Select
                        placeholder="Select Role"
                        options={roleList}
                        mode="multiple"
                        allowClear
                        showSearch
                        onChange={roleListChangeFn}
                        optionFilterProp="label"
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      />
                    </Form.Item>

                    <Form.Item name="companyIds" label="Company">
                      <Select
                        placeholder="Select Company"
                        mode="multiple"
                        options={companyList}
                        allowClear
                        // disabled={!editable}
                        showSearch
                        optionFilterProp="label"
                        filterOption={(input, option) =>
                          option.label
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      />
                    </Form.Item>

                    <Form.Item name="ownerIds" label="Owner">
                      <Select
                        placeholder="Select Owner"
                        options={ownerList}
                        mode="multiple"
                        allowClear
                        // disabled={!editable}
                        showSearch
                        optionFilterProp="label"
                        filterOption={(input, option) =>
                          option.label
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      />
                    </Form.Item>
                    <Form.Item name="trustIds" label="Trust">
                      <Select
                        placeholder="Select Trust"
                        options={trustList}
                        mode="multiple"
                        allowClear
                        // disabled={!editable}
                        showSearch
                        optionFilterProp="label"
                        filterOption={(input, option) =>
                          option.label
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      />
                    </Form.Item>

                    <Form.Item name="groupIds" label="Group">
                      <Select
                        placeholder="Select Group"
                        options={groupList}
                        mode="multiple"
                        allowClear
                        showSearch
                        // disabled={!editable}
                        optionFilterProp="label"
                        filterOption={(input, option) =>
                          option.label
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      />
                    </Form.Item>

                    <Form.Item name="propIds" label="Prop">
                      <Select
                        placeholder="Select Prop"
                        mode="multiple"
                        options={propList}
                        allowClear
                        showSearch
                        // disabled={!editable}
                        filterOption={false}
                        onSearch={(value) => {
                          setSearchPropValue(value);
                          getProp(value);
                        }}
                        notFoundContent={
                          setSearchPropValue ? "No results" : "Type to search"
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col span={7}>
                    <div
                      style={{
                        marginBottom: "16px",
                        fontWeight: "bold",
                        fontSize: "20px",
                        marginLeft: "20px",
                      }}
                    >
                      Accounts Payable Access
                    </div>
                    <Form.Item
                      name="viewIds"
                      label="View Others' Approval Request & Process"
                      labelCol={{ span: 24 }}
                    >
                      <Select
                        mode="multiple"
                        showSearch
                        placeholder="Assign To"
                        optionFilterProp="label"
                        onChange={handleChangeView}
                        onClear={handleClearView}
                        allowClear
                        onBlur={() => setIsSelectVisible(false)}
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        options={accountData || []}
                        loading={loading}
                        style={{ width: "100%" }}
                       
                      />
                    </Form.Item>

                    <Form.Item
                      name="showIds"
                      label="Who Can View My Approval Request"
                      labelCol={{ span: 24 }}
                    >
                      <Select
                        mode="multiple"
                        showSearch
                        placeholder="Assign To"
                        optionFilterProp="label"
                        onChange={handleChangeUpdata}
                        onClear={handleClear}
                        allowClear
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        options={accountViewData || []} 
                        loading={loading}
                        notFoundContent={loading ? "Loading..." : "No data"}
                        style={{ width: "100%" }}
                        
                      />
                    </Form.Item>

                    <div
                      style={{
                        marginBottom: "16px",
                        fontWeight: "bold",
                        fontSize: "20px",
                        marginLeft: "20px",
                      }}
                    >
                      Major Project
                    </div>

                    <Form.Item
                      name="isContractManager"
                      label="P.M"
                      labelCol={{ span: 6 }}
                      wrapperCol={{ span: 18 }}
                    >
                      <Select
                        placeholder="Select Group"
                        options={isContractManagerList}
                        allowClear
                        showSearch
                        optionFilterProp="label"
                        filterOption={(input, option) =>
                          option.label
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        style={{ width: "100%" }}
                      />
                    </Form.Item>
                    <Form.Item
                      name="managerIds"
                      label="View Other Account"
                      labelCol={{ span: 6 }}
                      wrapperCol={{ span: 18 }}
                    >
                      <Select
                        placeholder="Select Owner"
                        options={accountData}
                        mode="multiple"
                        allowClear
                        showSearch
                        optionFilterProp="label"
                        filterOption={(input, option) =>
                          option.label
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        style={{ width: "100%" }}
                      />
                    </Form.Item>
                    
                    <div
                      style={{
                        marginBottom: "16px",
                        fontWeight: "bold",
                        fontSize: "20px",
                        marginLeft: "20px",
                      }}
                    >
                      App
                    </div>
    
                    <Form.Item
                      name="enableApp"
                      label="App Active"
                      labelCol={{ span: 4 }}
                      wrapperCol={{ span: 20 }}
                      rules={[
                        {
                          required: true,
                          message: "Please Select App Active",
                        },
                      ]}
                    >
                      <Select
                        placeholder="Select Group"
                        options={[
                          { value: 1, label: "Active" },
                          { value: 0, label: "Inactive" },
                        ]}
                        allowClear
                        showSearch
                        optionFilterProp="label"
                        filterOption={(input, option) =>
                          option.label.toLowerCase().includes(input.toLowerCase())
                        }
                        style={{ width: "100%" }}
                      />
                    </Form.Item>
                    <div
                      style={{
                        marginBottom: "16px",
                        fontWeight: "bold",
                        fontSize: "20px",
                        marginLeft: "20px",
                      }}
                    >
                      Create And Edit Info
                    </div>
                    
                    <Form.Item name="createName" label="Created By">
                      <Input
                        placeholder=""
                        allowClear
                       readOnly
                      />
                    </Form.Item>

                    
                    <Form.Item name="cdate" label="Created Date">
                      <Input
                        placeholder=""
                        allowClear
                        readOnly
                      />
                    </Form.Item>
                    
                    <Form.Item name="updateName" label="Last Edited By">
                      <Input
                        placeholder=""
                        allowClear
                       readOnly
                      />
                    </Form.Item>
                    
                    <Form.Item name="udate" label="Last Edited Date">
                      <Input
                        placeholder=""
                        allowClear
                       readOnly
                      />
                    </Form.Item>

                                  <div
                                style={{
                                  marginBottom: "16px",
                                  fontWeight: "bold",
                                  fontSize: "20px",
                                  marginLeft: "20px",
                                }}
                              >
                               Insurance
                              </div>
              
                         <Form.Item
                  name="isInsuranceAgent"
                  label="View All"
                  labelCol={{ span: 6 }}
                  wrapperCol={{ span: 18 }}
                >
                  <Select
                    placeholder="Select Insurance Agent"
                    options={isInsuranceAgentList}
                    allowClear
                    style={{ width: "100%" }}
                       onChange={(value) => {
                      if (value !== 2) {
                       form.setFieldsValue({
                        agentIds: []
                        });

                      // 清掉校验状态
                        form.validateFields(["agentIds"]);}}}/>
                </Form.Item>
              
              
                <Form.Item shouldUpdate noStyle>
                  {({ getFieldValue }) => {
                    const type = getFieldValue("isInsuranceAgent");
              
                    return (
                      <Form.Item
                        name="agentIds"
                        label="View Agent"
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 18 }}
                       rules={ isAgentRequired ? [{ required: true, message: "Select Agent" }]: []}
                      >
                     <Select
    mode="multiple"
    placeholder="Select Agent"
    options={anetList}
    loading={agentLoading}
    allowClear
    showSearch
    optionFilterProp="label"
    disabled={!isAgentRequired}
    onDropdownVisibleChange={(open) => open && getAgentTypeList()}
  />
</Form.Item>
                    );
                  }}
                </Form.Item>      
                  </Col>
                  <Col span={10}>
                    <div
                      style={{
                        marginBottom: "16px",
                        fontWeight: "bold",
                        fontSize: "20px",
                        marginLeft: "20px",
                      }}
                    >
                      Role&Permission
                    </div>
                    <Row gutter={[16, 16]}>
                      <Tabs
                        tabPosition="left"
                        style={{ width: '100%' }}
                        items={roleTabs.map((item, i) => {
                          return {
                            label: (
                              <Tooltip title={item.label}>
                                <div style={{
                                  maxWidth: 230,
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}>
                                  {item.label}
                                </div>
                              </Tooltip>
                            ),
                            key: item.value,
                            children: (
                              <Tree
                              className="my-tree-wrapper"
                                disabled
                                key={item.value}
                                treeData={item.menuList}
                                checkedKeys={item.checkedKeys}
                                defaultExpandAll
                                checkable
                                checkStrictly={true}
                                selectable={false}
                                style={{
                                  width: "100%",
                                  height: 820,
                                  border: "1px dashed #d9d9d9",
                                  borderRadius: "4px",
                                  padding: "10px",
                                }}
                                height={800}
                              />
                            )
                          }
                        })}
                      />
                    </Row>
                  </Col>
                </Row>

                <Form.Item name="accountId" noStyle>
                  <Input type="hidden" />
                </Form.Item>
              </Form>
            </div>
          </div>
        </Flex>
        </Spin>
      </Modal>
  );
});

export default UpdateModal;
